module.exports = __webpack_public_path__ + "static/media/instagram.6c667730.svg";